import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Toast, Button, Dialog } from 'react-weui';
import PropTypes from 'prop-types';

import { formatDate } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';

const Config = {
  // notifyDetail: {
  //   title: '企业通知详情',
  // },
  // notifyDetail: {
  //   title: '企业通知详情',
  // },
};

class NotifyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      error: null,
      redirect: null,
      detail: {},
      style2: {
        title: '',
        buttons: [
          {
            type: 'default',
            label: '取消',
            onClick: this.hideDialog.bind(this),
          },
          {
            type: 'primary',
            label: '确认',
            onClick: this.msgConfirm.bind(this),
          },
        ],
      },
      showIOS2: false,
      showToast: false,
      showLoading: false,
      showError: false,
    };
    const { match } = props;
    this.companyCode = match.params.companyCode;
    this.companyInfo = User.getCompanyInfo(this.companyCode);
    this.id = match.params.id;
    this.type = match.params.type;
    this.hideDialog = this.hideDialog.bind(this);
    this.successFn = this.successFn.bind(this);
    this.errorFn = this.errorFn.bind(this);
    this.handle = this.handle.bind(this);
    this.config = Config[props.type];
    this.isPurchase = true;
    this.dialogMsg = '';
    this.errorMsg = '';
    this.toastTimer = null;
    this.loadingTimer = null;
    this.errorTimer = null;
    this.notifyType = 2; //1：客户通知；2：供应商通知
  }

  init() {
    if (typeof this.type === 'string') {
      this.type = Number(this.type);
    }
    User.init(this.companyCode).then(response => {
      if (response.success) {
        this.setState({ inited: true });
        // this.companyCode = User.getCompanyCode();
        this.getDetail();
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  componentDidMount() {
    this.init();
  }

  hideDialog() {
    this.setState({
      showIOS2: false,
    });
  }

  getDetail() {
    let postbody = {
      apiPath:
        this.type !== 1 ? '/oss/compNotify/detail' : '/oss/message/detail',
      id: this.id,
      companyCode: this.companyCode,
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = { ...response.data };
        //根据收发件接口，取this.notifyType，1：客户通知；2：供应商通知
        if (this.type !== 1) {
          //发件箱详情
          this.notifyType = data.notifyType === 1 ? 2 : 1;
        } else {
          //收件箱详情
          this.notifyType = data.notifyType;
        }
        this.setState({ detail: data });
        //打开详情后置为已读
        if (data.readFlag === 0) {
          let params = {
            id: this.id,
            companyCode: this.companyCode,
            apiPath: '/oss/message/read',
          };
          Http.post('/api/cloudCenter', params).then(res => {});
        }
      } else {
        this.setState({
          error: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  handle() {
    this.dialogMsg = '我已阅读并确认信息';
    this.setState({ showIOS2: true });
  }

  //客户通知确认
  msgConfirm() {
    this.hideDialog();
    this.setState({ showLoading: true });
    let postbody = {
      id: this.id,
      vendorConfirmStatus: 1,
      apiPath: '/oss/message/vendorConfirm',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        this.successFn(() => {
          this.getDetail();
        });
      } else {
        this.errorFn(response.errorMsg);
      }
    });
  }

  successFn(cb) {
    this.setState({ showLoading: false });
    this.setState({ showToast: true });
    this.toastTimer = setTimeout(() => {
      this.setState({ showToast: false });
      if (typeof cb === 'function') {
        cb();
      }
    }, 2000);
  }

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showLoading: false });
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 3000);
  }

  componentWillUnmount() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
    }
    if (this.errorTimer) {
      clearTimeout(this.errorTimer);
    }
  }

  render() {
    //const { data, actions } = this.props;
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }

    if (this.state.redirect !== null) {
      return <Redirect to={this.state.redirect} />;
    }

    let detail = this.state.detail;

    return (
      <div>
        <TopNav inited={this.state.inited} />
        <div className="pb50">
          <div className="order-detail-block">
            <div className="order-detail-title">
              <label>企业通知详情</label>
            </div>
            <ul>
              <li>
                <label className="order-detail-label">通知标题</label>
                <div className="order-detail-value">{detail.msgTitle}</div>
              </li>
              {this.type !== 1 && (
                <li>
                  <label className="order-detail-label">收件企业</label>
                  <div className="order-detail-value">
                    {Array.isArray(detail.receiveCompList) &&
                      detail.receiveCompList.map((item, index) => (
                        <span key={item.receiverXkUniqueCode + index}>
                          <span>
                            {item.companyName || item.innerVendorName}
                          </span>
                          {index > 0 && <span>；</span>}
                        </span>
                      ))}
                  </div>
                </li>
              )}
              {this.type === 1 && (
                <li>
                  <label className="order-detail-label">发件企业</label>
                  <div className="order-detail-value">
                    {detail.sendCompanyName}
                  </div>
                </li>
              )}
              <li>
                <label className="order-detail-label">优先级</label>
                <div className="order-detail-value">
                  <span className={detail.priorityValue === 9 ? 'orange' : ''}>
                    {detail.priorityValue === 9 ? '重要' : '一般'}
                  </span>
                </div>
              </li>
              <li>
                <label className="order-detail-label">发送日期</label>
                <div className="order-detail-value">
                  {formatDate(
                    detail.publishTime || detail.sendTime,
                    'YYYY-MM-DD HH:mm:ss'
                  )}
                </div>
              </li>
              <li>
                <label className="order-detail-label">发送人</label>
                <div className="order-detail-value">{detail.senderName}</div>
              </li>
              {this.notifyType === 2 && (
                <li>
                  <label className="order-detail-label">类型</label>
                  <div className="order-detail-value">
                    {detail.compNotifyType === 2 ? '集团群发' : '普通'}
                  </div>
                </li>
              )}
              <li>
                <label className="order-detail-label">通知内容</label>
                <div className="order-detail-value msg-content">
                  {detail.msgContent}
                </div>
              </li>
            </ul>
            {detail.isVendorConfirm === 1 && (
              <div className="confirm">
                <p className="title">需要供应商确认内容：</p>
                <div>{detail.vendorConfirmContent}</div>
              </div>
            )}
            {this.notifyType === 2 && (
              <div className="confirm-list">
                <ul>
                  {Array.isArray(detail.receiveCompList) &&
                    detail.receiveCompList.map((item, index) => (
                      <li key={index}>
                        <span
                          className={
                            item.vendorConfirmStatus === 1
                              ? 'u-sign green'
                              : 'u-sign'
                          }
                        >
                          {item.vendorConfirmStatus === 1 ? '已确认' : '待确认'}
                        </span>
                        {item.companyName}
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        {this.notifyType === 1 && detail.isVendorConfirm === 1 && (
          <div className="wrap m-flex-box fixed-bottom">
            {detail.vendorConfirmStatus === 0 && (
              <Button
                type="default"
                onClick={() => {
                  this.handle();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                确认
              </Button>
            )}
            {detail.vendorConfirmStatus === 1 && (
              <Button type="default" className="m-flex-item u-btn u-btn_gray">
                已确认
              </Button>
            )}
          </div>
        )}
        <Dialog
          type="ios"
          title={this.state.style2.title}
          buttons={this.state.style2.buttons}
          show={this.state.showIOS2}
        >
          {this.dialogMsg}
        </Dialog>
        <Toast icon="success-no-circle" show={this.state.showToast}>
          完成
        </Toast>
        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

NotifyDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotifyDetail);
